import { BaseInfoIcon } from "../../Icons";
import { Typo } from "../../Typo";

type SheetNoticeProps = {
  message: string;
};

/**
 * The outlined info notice both overlays open with — a bordered box rather
 * than the tinted `WidgetNotification` bar used inside the widget card.
 */
export const SheetNotice = ({ message }: SheetNoticeProps) => (
  <div
    role="status"
    className="flex items-center gap-4 rounded-lg border border-stroke-primary p-3"
  >
    <div className="flex min-w-0 flex-1 items-start gap-2">
      <span className="flex shrink-0 items-start py-0.5 text-icon-brand-default">
        <BaseInfoIcon height={16} width={16} aria-hidden="true" />
      </span>
      <Typo
        element="p"
        smType="bodyXS"
        lgType="bodySM"
        textColor="text-text-primary"
      >
        {message}
      </Typo>
    </div>
  </div>
);
